module.exports = __webpack_public_path__ + "static/teen-girl-having-chiropractic-back-adjustment-58de9882bc9235db8f54628a6627ea78.webp";